// extracted by mini-css-extract-plugin
export default {"deleteBook_container":"DeleteBook_deleteBook_container__IrJz5","deleteBook_popup":"DeleteBook_deleteBook_popup__9Uv6o","btn_container":"DeleteBook_btn_container__hE6FN"};